module.exports = __webpack_public_path__ + "img/textoT2C-transparent_v2.92758a86.png";